/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, observable } from 'mobx';
import { ProductType } from '@veeam-vspc/models/web-controllers';

export class ConsumedPointsStore {
    @observable productType = ProductType.All;

    @action.bound
    setProductType(v: ProductType): void {
        this.productType = v;
    }
}
